document.addEventListener('DOMContentLoaded', () => {
  const filterSection = document.querySelector('.filter-section-inner-content');
  if (!filterSection) return;

  const searchYearData = localStorage.getItem('yeardata');

  if (searchYearData === null) {
    // document.querySelector('.collection_filter')?.classList.add('loading');
  }


  function setCookie(cname, cvalue, hours) {
    const d = new Date();
    d.setTime(d.getTime() + (hours * 60 * 60 * 1000));
    document.cookie = `${cname}=${cvalue};expires=${d.toUTCString()};path=/`;
  }

  function getCookie(cname) {
    const name = cname + "=";
    return document.cookie
      .split(';')
      .map(c => c.trim())
      .find(c => c.startsWith(name))
      ?.substring(name.length) || "";
  }

  function checkCookie() {
    if (!getCookie("homepage")) {
      localStorage.removeItem("yeardata");
    }
  }
  checkCookie();


  function allartworks() {
    fetch('https://dev.shopifyexperthelp.com/app/project_app/Autotech/list_product.php')
      .then(res => res.json())
      .then(respData => {
        if (respData.status === 1) {
          const storesa = respData.jsonData;

          const checkFilter = document.getElementById('checkFilter');
          if (checkFilter) checkFilter.innerHTML = storesa;

          localStorage.setItem('yeardata', storesa);

          const hiddenCheckFilter = document.querySelector('.hiddenSelect .checkFilter');
          if (hiddenCheckFilter) hiddenCheckFilter.innerHTML = storesa;

          setTimeout(processOptions, 1000);
        }
      })
      .catch(err => console.error('Fetch error:', err));
  }

  if (searchYearData === null) {
    allartworks();
  } else {
    const hiddenCheckFilter = document.querySelector('.hiddenSelect .checkFilter');
    if (hiddenCheckFilter) hiddenCheckFilter.innerHTML = searchYearData;

    setTimeout(() => {
      processOptions();
      setCookie("homepage", "verification", 1);
      checkCookie();
    }, 1000);
  }

 function processOptions() {
  const hiddenSelect = document.querySelector('.hiddenSelect');
  if (!hiddenSelect) return;

  const getDataSearch = hiddenSelect.innerHTML;
  if (!getDataSearch) return;

  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = getDataSearch;

  const yearFilterA = [];

  tempDiv.querySelectorAll('option[data-value]').forEach(option => {
    const filterloop = option.value;
    if (!filterloop) return;

    const filterSplit = filterloop.split('_');
    if (filterSplit.length < 2) return;

    yearFilterA.push(filterSplit[1]);
  });

  const uniqueYears = [...new Set(yearFilterA)];

  const yearSelect = document.getElementById('yearFilterSelect');
  if (!yearSelect) return;

  yearSelect.querySelectorAll('option:not([data-attr="disabled-val"])')
    .forEach(opt => opt.remove());


  uniqueYears
    .sort((a, b) => b.localeCompare(a))
    .forEach(year => {
      const option = document.createElement('option');
      option.value = year;
      option.dataset.value = year.toLowerCase().replace(/\s+/g, '-');
      option.textContent = year.toUpperCase();
      yearSelect.appendChild(option);
    });
function updateFindButton() {
  const filters = document.querySelectorAll('.filter-main');
  const findButton = document.querySelector('.findbutton');

  // At least one filter is enabled
  const hasEnabledFilter = [...filters].some(
    filter => !filter.classList.contains('disabled')
  );

  if (hasEnabledFilter) {
    findButton.classList.remove('disabled', 'disabled_find');
  } else {
    findButton.classList.add('disabled', 'disabled_find');
  }
}

updateFindButton();
  // document.querySelector('.collection_filter')?.classList.remove('loading');
  // document.querySelector('.Year_Filter')?.classList.remove('disabled');
  // document.querySelector('.main_filter')?.classList.remove('ymm_load');
}


// document.addEventListener('change', function (e) {


//   if (e.target.id === 'yearFilterSelect') {
//     const vehicalVal = e.target.value;
//     // document.querySelector('#year_hidden').value = vehicalVal;

//     document.querySelector('.Mak_Filter')
//       ?.classList.toggle('disabled', !vehicalVal);

//     document.querySelectorAll('#makFilterSelect option[data-value]')
//       .forEach(opt => opt.remove());

//     const makfilterArry = [];

//     document.querySelectorAll('.checkFilter option').forEach(option => {
//       const filterVal = option.value.toLowerCase();
//       if (filterVal.includes(vehicalVal.toLowerCase() + '_')) {
//         const splitfilter = option.textContent.trim().split('_');
//         makfilterArry.push(splitfilter[2]);
//       }
//     });

//     const uniqueValue = [...new Set(makfilterArry.map(v => v.toLowerCase()))]
//       .map(v => makfilterArry.find(x => x.toLowerCase() === v))
//       .sort((a, b) => a.localeCompare(b));

//     const makSelect = document.getElementById('makFilterSelect');

//     uniqueValue.forEach(value => {
//       const option = document.createElement('option');
//       option.value = value;
//       option.dataset.value = value.toLowerCase().replace(/\s+/g, '-');
//       option.textContent = value.toUpperCase();
//       makSelect.appendChild(option);
//     });

//     resetSelect('make');
//   }


//   if (e.target.id === 'makFilterSelect') {

//     const vehicalVal = e.target.value;
//     document.querySelector('#make_hidden').value = vehicalVal;

//     document.querySelector('.Model_Filter')
//       ?.classList.toggle('disabled', !vehicalVal);

//     const year = document.querySelector('#year_hidden').value;
//     const check_ymm = `${year}_${vehicalVal}_`;

//     document.querySelectorAll('#modelFilterSelect option[data-value]')
//       .forEach(opt => opt.remove());

//     const makfilterArry = [];

//     document.querySelectorAll('.checkFilter option').forEach(option => {
//       if (option.value.toLowerCase().includes(check_ymm.toLowerCase())) {
//         makfilterArry.push(option.textContent.trim().split('_')[3]);
//       }
//     });

//     populateSelect('modelFilterSelect', makfilterArry);
//     resetSelect('model');
//   }

//   if (e.target.id === 'modelFilterSelect') {

//     const vehicalVal = e.target.value;
//     document.querySelector('#model_hidden').value = vehicalVal;

//     document.querySelector('.vehicle_Filter')
//       ?.classList.toggle('disabled', !vehicalVal);

//     const year = document.querySelector('#year_hidden').value;
//     const make = document.querySelector('#make_hidden').value;
//     const check_ymm = `${year}_${make}_${vehicalVal}_`;

//     document.querySelectorAll('#vehicleFilterSelect option[data-value]')
//       .forEach(opt => opt.remove());

//     const makfilterArry = [];

//     document.querySelectorAll('.checkFilter option').forEach(option => {
//       if (option.value.toLowerCase().includes(check_ymm.toLowerCase())) {
//         makfilterArry.push(option.textContent.trim().split('_')[4]);
//       }
//     });

//     populateSelect('vehicleFilterSelect', makfilterArry);
//     resetSelect('vehicle');
//   }


//   if (e.target.id === 'vehicleFilterSelect') {

//     const vehicalVal = e.target.value;
//     document.querySelector('#vehicle_hidden').value = vehicalVal;

//     document.querySelector('.findbutton')
//       ?.classList.toggle('disabled_find', !vehicalVal);
//   }
// });


// function populateSelect(selectId, values) {
//   const select = document.getElementById(selectId);

//   const unique = [...new Set(values.map(v => v.toLowerCase()))]
//     .map(v => values.find(x => x.toLowerCase() === v))
//     .sort((a, b) => a.localeCompare(b));

//   unique.forEach(value => {
//     const option = document.createElement('option');
//     option.value = value;
//     option.dataset.value = value.toLowerCase().replace(/\s+/g, '-');
//     option.textContent = value.toUpperCase();
//     select.appendChild(option);
//   });
// }

// function resetSelect(level) {

//   if (level === 'make') {
//     document.querySelector('#make_hidden').value = '';
//     document.querySelector('#makFilterSelect option[data-attr="disabled-val"]').selected = true;

//     document.querySelector('#model_hidden').value = '';
//     document.querySelector('.Model_Filter')?.classList.add('disabled');
//     document.querySelector('#modelFilterSelect option[data-attr="disabled-val"]').selected = true;

//     document.querySelector('#vehicle_hidden').value = '';
//     document.querySelector('.vehicle_Filter')?.classList.add('disabled');
//     document.querySelector('#vehicleFilterSelect option[data-attr="disabled-val"]').selected = true;

//     document.querySelector('.findbutton')?.classList.add('disabled_find');
//   }

//   if (level === 'model') {
//     document.querySelector('#model_hidden').value = '';
//     document.querySelector('#modelFilterSelect option[data-attr="disabled-val"]').selected = true;

//     document.querySelector('#vehicle_hidden').value = '';
//     document.querySelector('.vehicle_Filter')?.classList.add('disabled');
//     document.querySelector('#vehicleFilterSelect option[data-attr="disabled-val"]').selected = true;

//     document.querySelector('.findbutton')?.classList.add('disabled_find');
//   }

//   if (level === 'vehicle') {
//     document.querySelector('#vehicle_hidden').value = '';
//     document.querySelector('#vehicleFilterSelect option[data-attr="disabled-val"]').selected = true;
//     document.querySelector('.findbutton')?.classList.add('disabled_find');
//   }
// }


// document.addEventListener('click', function (e) {
//   if (!e.target.matches('#findMobileValue')) return;

//   const vehicle = document.querySelector('#vehicle_hidden').value;
//   const make = document.querySelector('#make_hidden').value;
//   const year = document.querySelector('#year_hidden').value;
//   const modal = document.querySelector('#model_hidden').value;

//   const type = window.location.pathname === '/' ? 'collection' : 'product';
//   const find = `/search?options%5Bunavailable_products%5D=show&options%5Bprefix%5D=last&q=Filter_${year}_${make}_${modal}_${vehicle}&type=${type}`;

//   window.location.href = find;
// });

// document.addEventListener('click', function (e) {
//   if (!e.target.matches('#clearfilter')) return;

//   document.querySelector('#year_hidden').value = '';
//   document.querySelector('#make_hidden').value = '';
//   document.querySelector('#model_hidden').value = '';
//   document.querySelector('#vehicle_hidden').value = '';

//   document.querySelector('#yearFilterSelect option[data-attr="disabled-val"]').selected = true;
//   document.querySelector('#makFilterSelect option[data-attr="disabled-val"]').selected = true;
//   document.querySelector('#modelFilterSelect option[data-attr="disabled-val"]').selected = true;
//   document.querySelector('#vehicleFilterSelect option[data-attr="disabled-val"]').selected = true;

//   document.querySelector('.Mak_Filter')?.classList.add('disabled');
//   document.querySelector('.Model_Filter')?.classList.add('disabled');
//   document.querySelector('.vehicle_Filter')?.classList.add('disabled');
//   document.querySelector('.findbutton')?.classList.add('disabled_find')
// });


// function populateSelect(selectId, values) {
//   const select = document.getElementById(selectId);

//   [...new Set(values.map(v => v.toLowerCase()))]
//     .sort()
//     .forEach(val => {
//       const original = values.find(v => v.toLowerCase() === val);
//       const option = document.createElement('option');
//       option.value = original;
//       option.dataset.value = original.toLowerCase().replace(/\s+/g, '-');
//       option.textContent = original.toUpperCase();
//       select.appendChild(option);
//     });

//   document.querySelector('.findbutton')?.classList.add('disabled_find');
// }

// function resetBelow(level) {
//   const map = {
//     make: ['make_hidden', 'Model_Filter', 'modelFilterSelect'],
//     model: ['model_hidden', 'vehicle_Filter', 'vehicleFilterSelect'],
//     vehicle: ['vehicle_hidden']
//   };

//   if (!map[level]) return;

//   const hiddenInput = document.getElementById(map[level][0]);
//   if (hiddenInput) hiddenInput.value = '';

//   const filterClass = map[level][1];
//   if (filterClass) {
//     const filterEl = document.querySelector(`.${filterClass}`);
//     if (filterEl) filterEl.classList.add('disabled');
//   }

//   const selectId = map[level][2];
//   if (selectId) {
//     const selectEl = document.getElementById(selectId);
//     if (selectEl) selectEl.selectedIndex = 0;
//   }
// }



});


// Main product Filter YMM

// const form = document.querySelector('.form-validation');

// const main_yearVal = form.querySelectorAll('#yearFilterSelect_main_product [data-value]:checked').length;

// const main_makeVal = form.querySelectorAll('#makFilterSelect_main_product [data-value]:checked').length;

// const main_modelVal = form.querySelectorAll('#modelFilterSelect_main_product [data-value]:checked').length;

// const main_vehicleVal = form.querySelectorAll('#vehicleFilterSelect_main_product [data-value]:checked').length;

// const addBtn = document.querySelector('.main_productN').querySelector('.itg_add_btn');

// if ( main_yearVal === 0 || main_makeVal === 0 || main_modelVal === 0 || main_vehicleVal === 0) {
//   addBtn.classList.add('disabled_input');
// } else {
//   addBtn.classList.remove('disabled_input');
// }


// document.addEventListener('change', function (e) {
//   if (!e.target.matches('#yearFilterSelect_main_product')) return;

//   const yearSelect = e.target;

//   /* loading state */
//   const makeFilterWrapper = document.querySelector('.main_Mak_Filter_product');
//   makeFilterWrapper.classList.add('loading');

//   setTimeout(() => {
//     makeFilterWrapper.classList.remove('loading');
//   }, 1000);

//   /* set hidden input */
//   const vehicalVal = yearSelect.value;
//   const yearHidden = document.querySelector('#year_hidden_main_product[type="hidden"]');
//   yearHidden.value = vehicalVal;

//   if (yearHidden.value) {
//     makeFilterWrapper.classList.remove('disabled');
//   } else {
//     makeFilterWrapper.classList.add('disabled');
//   }

//   /* build make filter options */
//   const check_ymm = vehicalVal + '_';
//   const makfilterArry = [];

//   const makeSelect = document.getElementById('makFilterSelect_main_product');

//   // remove existing data-value options
//   makeSelect.querySelectorAll('option[data-value]').forEach(opt => opt.remove());

//   document.querySelectorAll('.main_filter-check option').forEach(option => {
//     const filterVal = option.value;

//     if (filterVal.includes(check_ymm)) {
//       const getfilter = option.textContent.trim();
//       const splitfilter = getfilter.split('_');
//       const filterOne = splitfilter[2];
//       makfilterArry.push(filterOne);
//     }
//   });

//   // unique values
//   const uniqueValue = makfilterArry.filter((itm, i, arr) => arr.indexOf(itm) === i);

//   uniqueValue.forEach(value => {
//     const dataval = value.toLowerCase();
//     const dataText = value.toUpperCase();
//     const datavalue = dataval.replace(' ', '-');

//     const option = document.createElement('option');
//     option.className = 'optionList';
//     option.dataset.value = datavalue;
//     option.value = value;
//     option.textContent = dataText;

//     makeSelect.appendChild(option);
//   });

//   // sort options alphabetically
//   const sortedOptions = Array.from(makeSelect.querySelectorAll('.optionList'))
//     .sort((a, b) => a.textContent.localeCompare(b.textContent));

//   sortedOptions.forEach(opt => makeSelect.appendChild(opt));

//   /* reset dependent fields */
//   document.querySelector('#make_hidden_main_product[type="hidden"]').value = '';
//   makeSelect.querySelector('option[data-attr="disabled-val"]')?.setAttribute('selected', true);

//   document.querySelector('#model_hidden_main_product[type="hidden"]').value = '';
//   document.querySelector('.Model_Filter_main_product').classList.add('disabled');
//   document
//     .querySelector('#modelFilterSelect_main_product option[data-attr="disabled-val"]')
//     ?.setAttribute('selected', true);

//   document.querySelector('#vehicle_hidden_main_product[type="hidden"]').value = '';
//   document.querySelector('.vehicle_Filter_main_product').classList.add('disabled');
//   document
//     .querySelector('#vehicleFilterSelect_main_product option[data-attr="disabled-val"]')
//     ?.setAttribute('selected', true);

//   /* validation check */
//   validateMainProduct();
// });


// document.addEventListener('change', function (e) {
//   if (!e.target.matches('#makFilterSelect_main_product')) return;

//   const makeSelect = e.target;
//   const modelWrapper = document.querySelector('.main_Model_Filter_product');

//   /* loading */
//   modelWrapper.classList.add('loading');
//   setTimeout(() => modelWrapper.classList.remove('loading'), 1200);

//   /* hidden input */
//   const vehicalVal = makeSelect.value;
//   const makeHidden = document.querySelector('#make_hidden_main_product[type="hidden"]');
//   makeHidden.value = vehicalVal;

//   if (makeHidden.value) {
//     modelWrapper.classList.remove('disabled');
//   } else {
//     modelWrapper.classList.add('disabled');
//   }

//   /* build model options */
//   const yearVal = document.querySelector('#year_hidden_main_product[type="hidden"]').value;
//   const check_ymm = `${yearVal}_${vehicalVal}_`;

//   const modelSelect = document.getElementById('modelFilterSelect_main_product');
//   modelSelect.querySelectorAll('option[data-value]').forEach(opt => opt.remove());

//   const models = [];

//   document.querySelectorAll('.main_filter-check option').forEach(opt => {
//     if (opt.value.includes(check_ymm)) {
//       const split = opt.textContent.trim().split('_');
//       models.push(split[3]);
//     }
//   });

//   [...new Set(models)]
//     .sort((a, b) => a.localeCompare(b))
//     .forEach(value => {
//       const option = document.createElement('option');
//       option.className = 'optionList';
//       option.dataset.value = value.toLowerCase().replace(' ', '-');
//       option.value = value;
//       option.textContent = value.toUpperCase();
//       modelSelect.appendChild(option);
//     });

//   /* reset lower filters */
//   document.querySelector('#model_hidden_main_product[type="hidden"]').value = '';
//   modelSelect.querySelector('option[data-attr="disabled-val"]')?.setAttribute('selected', true);

//   document.querySelector('#vehicle_hidden_main_product[type="hidden"]').value = '';
//   document.querySelector('.vehicle_Filter_main_product').classList.add('disabled');
//   document
//     .querySelector('#vehicleFilterSelect_main_product option[data-attr="disabled-val"]')
//     ?.setAttribute('selected', true);

//   validateMainProduct();
// });


// document.addEventListener('change', function (e) {
//   if (!e.target.matches('#modelFilterSelect_main_product')) return;

//   const modelSelect = e.target;
//   const vehicleWrapper = document.querySelector('.main_vehicle_Filter_product');

//   /* loading */
//   vehicleWrapper.classList.add('loading');
//   setTimeout(() => vehicleWrapper.classList.remove('loading'), 1500);

//   /* hidden input */
//   const vehicalVal = modelSelect.value;
//   const modelHidden = document.querySelector('#model_hidden_main_product[type="hidden"]');
//   modelHidden.value = vehicalVal;

//   if (modelHidden.value) {
//     vehicleWrapper.classList.remove('disabled');
//   } else {
//     vehicleWrapper.classList.add('disabled');
//   }

//   /* build vehicle options */
//   const yearVal = document.querySelector('#year_hidden_main_product[type="hidden"]').value;
//   const makeVal = document.querySelector('#make_hidden_main_product[type="hidden"]').value;
//   const check_ymm = `${yearVal}_${makeVal}_${vehicalVal}_`;

//   const vehicleSelect = document.getElementById('vehicleFilterSelect_main_product');
//   vehicleSelect.querySelectorAll('option[data-value]').forEach(opt => opt.remove());

//   const vehicles = [];

//   document.querySelectorAll('.main_filter-check option').forEach(opt => {
//     if (opt.value.includes(check_ymm)) {
//       const split = opt.textContent.trim().split('_');
//       vehicles.push(split[4]);
//     }
//   });

//   [...new Set(vehicles)]
//     .sort((a, b) => a.localeCompare(b))
//     .forEach(value => {
//       const option = document.createElement('option');
//       option.className = 'optionList';
//       option.dataset.value = value.toLowerCase().replace(' ', '-');
//       option.value = value;
//       option.textContent = value.toUpperCase();
//       vehicleSelect.appendChild(option);
//     });

//   document.querySelector('#vehicle_hidden_main_product[type="hidden"]').value = '';
//   vehicleSelect.querySelector('option[data-attr="disabled-val"]')?.setAttribute('selected', true);

//   validateMainProduct();
// });


// function validateMainProduct() {
//   const form = document.querySelector('.form-validation');
//   const addBtn = document.querySelector('.main_productN .itg_add_btn');

//   const isValid =
//     form.querySelectorAll('#yearFilterSelect_main_product [data-value]:checked').length &&
//     form.querySelectorAll('#makFilterSelect_main_product [data-value]:checked').length &&
//     form.querySelectorAll('#modelFilterSelect_main_product [data-value]:checked').length &&
//     form.querySelectorAll('#vehicleFilterSelect_main_product [data-value]:checked').length;

//   addBtn.classList.toggle('disabled_input', !isValid);
// }


// document.addEventListener('change', function (e) {
//   if (!e.target.matches('#vehicleFilterSelect_main_product')) return;

//   const vehicleSelect = e.target;
//   const vehicalVal = vehicleSelect.value;

//   /* hidden input */
//   document.querySelector('#vehicle_hidden_main_product[type="hidden"]').value = vehicalVal;

//   /* validation */
//   const form = document.querySelector('.form-validation');
//   const addBtn = document.querySelector('.main_productN .itg_add_btn');

//   const main_yearVal = form.querySelectorAll('#yearFilterSelect_main_product [data-value]:checked').length;
//   const main_makeVal = form.querySelectorAll('#makFilterSelect_main_product [data-value]:checked').length;
//   const main_modelVal = form.querySelectorAll('#modelFilterSelect_main_product [data-value]:checked').length;
//   const main_vehicleVal = form.querySelectorAll('#vehicleFilterSelect_main_product [data-value]:checked').length;

//   if (
//     main_yearVal === 0 ||
//     main_makeVal === 0 ||
//     main_modelVal === 0 ||
//     main_vehicleVal === 0
//   ) {
//     addBtn.classList.add('disabled_input');
//   } else {
//     addBtn.classList.remove('disabled_input');
//   }

//   /* build search URL */
//   const year = document.querySelector('#yearFilterSelect_main_product option:checked')?.value;
//   const make = document.querySelector('#makFilterSelect_main_product option:checked')?.value;
//   const model = document.querySelector('#modelFilterSelect_main_product option:checked')?.value;

//   const findcombine = `/search?type=product&q=Filter_${year}_${make}_${model}_${vehicalVal}`;
//   console.log(findcombine);

//   /* first AJAX (search page) */
//   fetch(findcombine)
//     .then(res => res.text())
//     .then(responseText => {
//       const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
//       const searchPage = responseHTML.querySelector('.search_page');
//       if (!searchPage) return;

//       searchPage.querySelectorAll('.search-result').forEach(result => {
//         const searchProductHandle =
//           result.querySelector('.search-text')?.dataset.handle;

//         if (!searchProductHandle) return;

//         const productTileTemplate = `/products/${searchProductHandle}`;
//         console.log(productTileTemplate);

//         /* second AJAX (product JSON) */
//         fetch(productTileTemplate)
//           .then(res => res.json())
//           .then(responseProduct => {
//             responseProduct.forEach(value => {
//               const productImage = value.image?.src || '';
//               const productTitle = value.title;

//               const variants = value.variants;
//               const tags = value.tags.split(', ');

//               let CollectionBase = '';
//               let TagAvi = 'NotTag';

//               const flyout = document.querySelector('.main_ymm_flyout');
//               const handleTag = flyout?.dataset.product;
//               const handleTitle = flyout?.dataset.p;

//               let PAvi = handleTitle === productTitle ? 'yesP' : 'NotP';

//               tags.forEach(tag => {
//                 const collectionKey = flyout?.dataset.collection;
//                 if (tag.includes(collectionKey)) {
//                   const aviCollection = tag.split('_');
//                   if (handleTag === aviCollection[1]) {
//                     CollectionBase = aviCollection[1];
//                     TagAvi = 'TagAvi';
//                   }
//                 }
//               });

//               const container = document.querySelector('.main_ymmc_product');

//               if (variants.length > 1) {
//                 const selectedOption = form
//                   .querySelector('.no-js select option:checked');

//                 const selectedText = selectedOption?.dataset.title || '';
//                 const selectOptionHTML = `
//                   <div class="main_product-option">
//                     <p>${selectedText}</p>
//                   </div>
//                 `;

//                 container.insertAdjacentHTML(
//                   'beforeend',
//                   `<label class="main_variant_option"
//                     data-product="${PAvi}"
//                     data-handle="${TagAvi}">
//                     <span>${productTitle}</span>
//                     ${selectOptionHTML}
//                   </label>`
//                 );
//               } else {
//                 container.insertAdjacentHTML(
//                   'beforeend',
//                   `<label class="main_product_option"
//                     data-product="${PAvi}"
//                     data-handle="${TagAvi}">
//                     <span>${productTitle}</span>
//                   </label>`
//                 );
//               }
//             });
//           })
//           .catch(() => console.log('errordata'));
//       });
//     })
//     .catch(() => console.log('errordata'));
// });




// Category Product

const productTemplate = document.querySelector('.template-product ');
const categoryProduct = document.querySelector('.category_product');

if (productTemplate && categoryProduct) {
  const yearVal = categoryProduct.querySelectorAll('#yearFilterSelect_product [data-value]:checked').length;

  const makeVal = categoryProduct.querySelectorAll('#makFilterSelect_product [data-value]:checked').length;

  const modelVal = categoryProduct.querySelectorAll('#modelFilterSelect_product [data-value]:checked').length;

  const vehicleVal = categoryProduct.querySelectorAll('#vehicleFilterSelect_product [data-value]:checked').length;

  const cateBtn = categoryProduct.querySelector('.cate_btn');

  cateBtn.classList.toggle('disabled_input',yearVal === 0 || makeVal === 0 || modelVal === 0 || vehicleVal === 0);
}


document.addEventListener('change', function (e) {
  if (!e.target.matches('#yearFilterSelect_product')) return;

  const yearSelect = e.target;
  const categoryProduct = document.querySelector('.category_product');

  /* reset UI */
  document.querySelector('.ymmc_product')?.replaceChildren();
  document.querySelectorAll('.custom_err').forEach(el => el.remove());
  document.getElementById('product-container')?.replaceChildren();

  const cateBtn = document.querySelector('.cate_btn');
  if (cateBtn) cateBtn.dataset.id = '';

  /* loading */
  const makeWrapper = document.querySelector('.Mak_Filter_product');
  makeWrapper.classList.add('loading');
  makeWrapper.querySelector('.custom_filter_option').setAttribute('disabled', true);
  setTimeout(() => {
    makeWrapper.classList.remove('loading');
    makeWrapper.querySelector('.custom_filter_option').removeAttribute('disabled');
  }, 1000);

  /* hidden input */
  const vehicalVal = yearSelect.value;
  document.querySelector('#year_hidden_product[type="hidden"]').value = vehicalVal;

  makeWrapper.classList.toggle('disabled', !vehicalVal);

  /* build make options */
  const check_ymm = `${vehicalVal}_`.toLowerCase();
  const makeSelect = document.getElementById('makFilterSelect_product');

  makeSelect.querySelectorAll('option[data-value]').forEach(opt => opt.remove());

  const makes = [];

  document.querySelectorAll('.checkFilter_product option').forEach(option => {
    if (option.value.toLowerCase().includes(check_ymm)) {
      const split = option.textContent.trim().split('_');
      makes.push(split[2]);
    }
  });

  [...new Map(makes.map(m => [m.toLowerCase(), m])).values()]
    .sort((a, b) => a.localeCompare(b))
    .forEach(value => {
      const option = document.createElement('option');
      option.className = 'optionList';
      option.dataset.value = value.toLowerCase().replace(/\s+/g, '-');
      option.value = value;
      option.textContent = value.toUpperCase();
      makeSelect.appendChild(option);
    });

  /* reset dependent filters */
  document.querySelector('#make_hidden_product[type="hidden"]').value = '';
  // makeSelect.querySelector('option[data-attr="disabled-val"]')?.setAttribute('selected', true);
  document.querySelector('#makFilterSelect_product option[data-attr="disabled-val"]').selected = true;
  document.querySelector('#model_hidden_product[type="hidden"]').value = '';
  document.querySelector('.Model_Filter_product')?.classList.add('disabled');
  document.querySelector('#modelFilterSelect_product option[data-attr="disabled-val"]').selected = true;

  document.querySelector('#vehicle_hidden_product[type="hidden"]').value = '';
  document.querySelector('.vehicle_Filter_product')?.classList.add('disabled');
  document.querySelector('#vehicleFilterSelect_product option[data-attr="disabled-val"]').selected = true;

  /* validation */
  const yearVal = categoryProduct.querySelectorAll('#yearFilterSelect_product [data-value]:checked').length;

  const makeVal = categoryProduct.querySelectorAll('#makFilterSelect_product [data-value]:checked').length;

  const modelVal = categoryProduct.querySelectorAll('#modelFilterSelect_product [data-value]:checked').length;

  const vehicleVal = categoryProduct.querySelectorAll('#vehicleFilterSelect_product [data-value]:checked').length;

  cateBtn.classList.toggle('disabled_input',yearVal === 0 || makeVal === 0 || modelVal === 0 || vehicleVal === 0);
});


document.addEventListener('change', function (e) {
  if (!e.target.matches('#makFilterSelect_product')) return;

  /* reset UI */
  document.querySelector('.ymmc_product')?.replaceChildren();
  document.querySelectorAll('.custom_err').forEach(el => el.remove());

  const cateBtn = document.querySelector('.cate_btn');
  if (cateBtn) cateBtn.dataset.id = '';

  /* loading */
  const modelWrapper = document.querySelector('.Model_Filter_product');
  modelWrapper.classList.add('loading');
  setTimeout(() => modelWrapper.classList.remove('loading'), 1200);

  /* hidden input */
  const vehicalVal = e.target.value;
  document.querySelector('#make_hidden_product[type="hidden"]').value = vehicalVal;

  modelWrapper.classList.toggle('disabled', !vehicalVal);

  /* build model options */
  const yearVal = document.querySelector('#year_hidden_product[type="hidden"]').value;
  const check_ymm = `${yearVal}_${vehicalVal}_`.toLowerCase();

  const modelSelect = document.getElementById('modelFilterSelect_product');
  modelSelect.querySelectorAll('option[data-value]').forEach(opt => opt.remove());

  const models = [];

  document.querySelectorAll('.checkFilter_product option').forEach(option => {
    if (option.value.toLowerCase().includes(check_ymm)) {
      const split = option.textContent.trim().split('_');
      models.push(split[3]);
    }
  });

  [...new Map(models.map(m => [m.toLowerCase(), m])).values()]
    .sort((a, b) => a.localeCompare(b))
    .forEach(value => {
      const option = document.createElement('option');
      option.className = 'optionList';
      option.dataset.value = value.toLowerCase().replace(/\s+/g, '-');
      option.value = value;
      option.textContent = value.toUpperCase();
      modelSelect.appendChild(option);
    });

  /* reset dependent filters */
  document.querySelector('#model_hidden_product[type="hidden"]').value = '';
  document.querySelector('#modelFilterSelect_product option[data-attr="disabled-val"]').selected = true;
  document.querySelector('#vehicle_hidden_product[type="hidden"]').value = '';
  document.querySelector('.vehicle_Filter_product')?.classList.add('disabled');
 document.querySelector('#vehicleFilterSelect_product option[data-attr="disabled-val"]').selected = true;

  /* validation */
  const category = document.querySelector('.category_product');
  const yearCount = category.querySelectorAll('#yearFilterSelect_product [data-value]:checked').length;
  const makeCount = category.querySelectorAll('#makFilterSelect_product [data-value]:checked').length;
  const modelCount = category.querySelectorAll('#modelFilterSelect_product [data-value]:checked').length;
  const vehicleCount = category.querySelectorAll('#vehicleFilterSelect_product [data-value]:checked').length;

  cateBtn.classList.toggle(
    'disabled_input',
    yearCount === 0 || makeCount === 0 || modelCount === 0 || vehicleCount === 0
  );
});

document.addEventListener('change', function (e) {
  if (!e.target.matches('#modelFilterSelect_product')) return;

  /* reset UI */
  document.querySelector('.ymmc_product')?.replaceChildren();
  document.querySelectorAll('.custom_err').forEach(el => el.remove());

  const cateBtn = document.querySelector('.cate_btn');
  if (cateBtn) cateBtn.dataset.id = '';

  /* loading */
  const vehicleWrapper = document.querySelector('.vehicle_Filter_product');
  vehicleWrapper.classList.add('loading');
  setTimeout(() => vehicleWrapper.classList.remove('loading'), 1500);

  /* hidden input */
  const vehicalVal = e.target.value;
  document.querySelector('#model_hidden_product[type="hidden"]').value = vehicalVal;

  vehicleWrapper.classList.toggle('disabled', !vehicalVal);

  /* build vehicle options */
  const yearVal = document.querySelector('#year_hidden_product[type="hidden"]').value;
  const makeVal = document.querySelector('#make_hidden_product[type="hidden"]').value;
  const check_ymm = `${yearVal}_${makeVal}_${vehicalVal}_`.toLowerCase();

  const vehicleSelect = document.getElementById('vehicleFilterSelect_product');
  vehicleSelect.querySelectorAll('option[data-value]').forEach(opt => opt.remove());

  const vehicles = [];

  document.querySelectorAll('.checkFilter_product option').forEach(option => {
    if (option.value.toLowerCase().includes(check_ymm)) {
      const split = option.textContent.trim().split('_');
      vehicles.push(split[4]);
    }
  });

  [...new Map(vehicles.map(v => [v.toLowerCase(), v])).values()]
    .sort((a, b) => a.localeCompare(b))
    .forEach(value => {
      const option = document.createElement('option');
      option.className = 'optionList';
      option.dataset.value = value.toLowerCase().replace(/\s+/g, '-');
      option.value = value;
      option.textContent = value.toUpperCase();
      vehicleSelect.appendChild(option);
    });

  document.querySelector('#vehicle_hidden_product[type="hidden"]').value = '';
  document.querySelector('#vehicleFilterSelect_product option[data-attr="disabled-val"]').selected = true;

  /* validation */
  const category = document.querySelector('.category_product');
  const yearCount = category.querySelectorAll('#yearFilterSelect_product [data-value]:checked').length;
  const makeCount = category.querySelectorAll('#makFilterSelect_product [data-value]:checked').length;
  const modelCount = category.querySelectorAll('#modelFilterSelect_product [data-value]:checked').length;
  const vehicleCount = category.querySelectorAll('#vehicleFilterSelect_product [data-value]:checked').length;

  cateBtn.classList.toggle(
    'disabled_input',
    yearCount === 0 || makeCount === 0 || modelCount === 0 || vehicleCount === 0
  );
});

document.addEventListener('change', function (e) {
  if (!e.target.matches('#vehicleFilterSelect_product')) return;
  /* reset UI */
  document.querySelector('.ymmc_product')?.replaceChildren();
  document.querySelectorAll('.custom_err').forEach(el => el.remove());

  const cateBtn = document.querySelector('.cate_btn');
  cateBtn.classList.add('loading');
  cateBtn.dataset.id = '';

  /* hidden input */
  const vehicalVal = e.target.value;
  document.querySelector('#vehicle_hidden_product[type="hidden"]').value = vehicalVal;

  /* build search URL */
  const year = document.querySelector('#yearFilterSelect_product option:checked')?.value;
  const make = document.querySelector('#makFilterSelect_product option:checked')?.value;
  const model = document.querySelector('#modelFilterSelect_product option:checked')?.value;

  const findcombine = `/search?type=product&q=Filter_${year}_${make}_${model}_${vehicalVal}`;
  // console.log(findcombine);

  /* first request (search page) */
  fetch(findcombine)
    .then(res => res.text())
    .then(responseText => {
      const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
      const searchPageHTML = responseHTML.querySelector('.search-page')?.innerHTML;
      if (!searchPageHTML) return;

      // console.log(searchPageHTML);

      const handleTag = document.querySelector('.ymm_flyout')?.dataset.product;

      const tempWrapper = document.createElement('div');
      tempWrapper.innerHTML = searchPageHTML;

      tempWrapper.querySelectorAll('.search-result').forEach(result => {
        const searchText = result.querySelector('.search-text');
        const searchCollection = searchText?.dataset.collection;
console.log('searchText',searchText);
        if (handleTag !== searchCollection) return;

        const searchProductHandle = searchText?.dataset.handle;
        if (!searchProductHandle) return;

        const productTileTemplate = `/products/${searchProductHandle}`;
console.log('productTileTemplate');

        /* second request (product HTML) */
        fetch(productTileTemplate)
          .then(res => res.text())
          .then(responseProduct => {
            const productHTML = new DOMParser()
              .parseFromString(responseProduct, 'text/html')
              .querySelector('.main_product-hide')?.innerHTML;

            if (!productHTML) return;
console.log(productHTML);
            const ymmcProduct = document.querySelector('.ymmc_product');
            ymmcProduct.insertAdjacentHTML('beforeend', productHTML);

            const labels = ymmcProduct.querySelectorAll('label');
            const firstInput = ymmcProduct.querySelector('input');

            if (firstInput) firstInput.checked = true;

            labels.forEach(label => {
              label.classList.toggle('input_hide', labels.length === 1);
            });

            const checkedInput = document.querySelector('.product_content input:checked');
            const checkedId = checkedInput?.dataset.id;

            document.querySelectorAll('.product_content').forEach(content => {
              const soldOutId = content.querySelector('input.sold_out')?.dataset.id;

              if (soldOutId === checkedId) {
                cateBtn.classList.add('outline', 'disabled_input');
                cateBtn.textContent = 'sold out';
              } else {
                cateBtn.classList.remove('outline', 'disabled_input');
                cateBtn.textContent = 'Add to cart';
              }
            });

            cateBtn.dataset.id = checkedId || '';
            cateBtn.classList.remove('loading');
          })
          .catch(() => console.log('errordata'));
      });
    })
    .catch(() => console.log('errordata'));
});

/* radio / checkbox change inside .ymmc_product */
document.addEventListener('change', function (e) {
  if (!e.target.matches('.ymmc_product input')) return;

  const variantId = e.target.dataset.id;
  const cateBtn = document.querySelector('.category_product .cate_btn');

  if (cateBtn) {
    cateBtn.dataset.id = variantId;
  }
});


/* select change inside .product_content */
document.addEventListener('change', function (e) {
  if (!e.target.matches('.product_content select')) return;

  const selectedValue = e.target.querySelector('option:checked')?.value;
  const cateBtn = document.querySelector('.category_product .cate_btn');

  if (cateBtn) {
    cateBtn.dataset.id = selectedValue;
  }
});

document.addEventListener('click', function (e) {
  const btn = e.target.closest('.category_product .cate_btn');
  if (!btn) return;

  e.preventDefault();

  const variantId = btn.dataset.id;

  const qtyInput = document.querySelector('.custom-qtn-btn-wrapper input[name="quantity"]');
  const qty = qtyInput ? Number(qtyInput.value) : 0;

  const checkedProduct = document.querySelector('.product_content input:checked');
  const qtyCh = checkedProduct ? Number(checkedProduct.dataset.qty) : 0;

  const yearProp = document.querySelector('#year_hidden_product[type="hidden"]')?.value || '';
  const makeProp = document.querySelector('#make_hidden_product[type="hidden"]')?.value || '';
  const modalProp = document.querySelector('#model_hidden_product[type="hidden"]')?.value || '';
  const vehicleProp = document.querySelector('#vehicle_hidden_product[type="hidden"]')?.value || '';

  const ymmProp = `${yearProp} ${makeProp} ${modalProp} ${vehicleProp}`.trim();

  /* quantity validation */
  const errorWrapper = document.querySelector('.custom-qtn-btn-main');

  if (qtyCh <= qty) {
    if (!errorWrapper.querySelector('.error')) {
      qtyInput.insertAdjacentHTML(
        'afterend',
        '<label class="error custom_err">Value must be lower</label>'
      );
    }
    return;
  }

  if (!variantId) return;

  const data = {
    id: variantId,
    quantity: qty,
    properties: {
      'For Vehicle': ymmProp
    }
  };

  /* add to cart */
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  })
    .then(res => res.json())
    .then(() => {
      /* reset main product filters */
     document.querySelector('#year_hidden_product[type="hidden"]').value = '';
      document.querySelector('.Year_Filter_product')?.classList.add('disabled');
      document.querySelector('#yearFilterSelect_product option[data-attr="disabled-val"]').selected = true;


     document.querySelector('#make_hidden_product[type="hidden"]').value = '';
      document.querySelector('.Mak_Filter_product')?.classList.add('disabled');
      document.querySelector('#makFilterSelect_product option[data-attr="disabled-val"]').selected = true;


      document.querySelector('#model_hidden_product[type="hidden"]').value = '';
      document.querySelector('.Model_Filter_product')?.classList.add('disabled');
      document.querySelector('#modelFilterSelect_product option[data-attr="disabled-val"]').selected = true;

      document.querySelector('#vehicle_hidden_product[type="hidden"]').value = '';
      document.querySelector('.vehicle_Filter_product')?.classList.add('disabled');
      document.querySelector('#vehicleFilterSelect_product option[data-attr="disabled-val"]').selected = true;

      window.location.href = '/cart';
    })
    .catch(() => console.log('cart add error'));
});
